import './css/animation.css'
import './css/dialog.css'
import './css/dialog_driver.css'
import dialog from './js/dialog'
export default dialog
